// Import the functions you need from the SDKs you need
import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getRemoteConfig, isSupported } from 'firebase/remote-config'
import { getStorage } from 'firebase/storage'
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY_FMS,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN_FMS,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID_FMS,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET_FMS,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_ID_FMS,
  appId: process.env.VUE_APP_FIREBASE_APP_ID_FMS,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID_FMS,
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
export const db = getFirestore(app)
export const functions = getFunctions(app)
export const storage = getStorage(app)
export const remoteConfig = async () => (await isSupported()) && getRemoteConfig(app)
